/**
 * Once-per-tab protocol-version forced reload (builder-ssot-consolidation
 * Phase 5 Session 5.8; ADR 0019 Decision A).
 *
 * Called when the API returns HTTP 426 with code `PROTOCOL_VERSION_REQUIRED`
 * OR when the SSE stream emits a `protocol_changed` event. Both transports
 * share this module so the once-per-tab sessionStorage guard applies across
 * BOTH paths.
 *
 * Guard rationale: `sessionStorage` (not `localStorage`) because the guard
 * is per-tab-session — a fresh tab SHOULD attempt the upgrade reload once;
 * closing+reopening clears it. A module-level `let reloaded=false` would be
 * reset by the reload itself (new JS context) and cannot prevent a loop.
 * Belt-and-suspenders against a misconfigured deploy where the new bundle
 * still 426s (which would otherwise infinite-loop). ADR 0019.
 */

const RELOAD_FLAG = 'arcanum:protocol-reloaded';

/** Once-per-tab forced reload on protocol-version break (ADR 0019). */
export function triggerProtocolReload(): void {
  if (typeof window === 'undefined') return;
  if (sessionStorage.getItem(RELOAD_FLAG)) return; // already reloaded this tab — no loop
  sessionStorage.setItem(RELOAD_FLAG, '1');
  window.location.reload();
}
